module.exports = __webpack_public_path__ + "img/46.68852b68.jpg";